import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import Scrollbar from 'react-smooth-scrollbar';
import {withRouter} from 'react-router-dom';
import classNames from 'classnames';
import TourSidebarContent from './TourSidebarContent';

class TourSidebar extends PureComponent {
  
  render() {
    let sidebarClass = classNames({
      'sidebar': true,
      'sidebar--show': this.props.sidebar.show,
    });
    
    return (
      <div className={sidebarClass}>
        <div className='sidebar__back' />
        <Scrollbar className='sidebar__scroll scroll'>
          <div className='sidebar__wrapper sidebar__wrapper--desktop'>
            <TourSidebarContent/>
          </div>
        </Scrollbar>
      </div>
    )
  }
}

export default withRouter(connect(state => {
  return {
    sidebar: state.sidebar,
    toggleTour: state.toggleTour
  };
})(TourSidebar));


// WEBPACK FOOTER //
// ./src/components/tour/dashboard/sidebar/TourSidebar.js